import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Row, Col, Typography } from 'antd';
import CButton from '../Button/index';
import { translate } from '../../actions/translateActions';
import { setContentDraft } from '../../actions/ContentAction';

const { Title } = Typography;

const FieldElement = ({
  edition,
  align,
  justify,
  height,
  title,
  lang,
  type,
  margin,
  alt,
  fieldIcon,
  name,
  children,
  entitiesCount
}) => {
  const dispatch = useDispatch();
  const contentDraft = useSelector(({ content }) => content.contentDraft);

  const limits = [];
  if (edition) {
    Object.keys(edition).forEach((key) => {
      limits.push({ [key]: edition[key] });
    });
  }

  const translateText = (text, key, title) => {
    dispatch(
      translate(text, key, title, (text, key, title) => {
        dispatch(
          setContentDraft({
            ...contentDraft,
            data: {
              ...contentDraft.data,
              [key]: {
                ...contentDraft.data[key],
                [title]: text
              }
            }
          })
        );
      })
    );
  };

  return (
    <Row
      align={align || 'top'}
      justify={justify || 'space-between'}
      style={{
        borderBottom: '1px solid #F0F4FF',
        boxSizing: 'border-box',
        height,
        padding: '24px 0px'
      }}
    >
      <Col
        align="start"
        span={8}
        style={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'row',
          marginBottom: margin || '40px',
          padding: '0px 40px 0px 35px'
        }}
      >
        <img
          alt={alt}
          height={32}
          src={fieldIcon}
          style={{
            background: '#F0F4FF',
            borderRadius: '6px',
            padding: '6px'
          }}
          width={32}
        />
        <Title
          style={{
            fontSize: '12px',
            fontWeight: 500,
            margin: '0px',
            paddingLeft: '12px'
          }}
        >
          {title} {entitiesCount && `(${entitiesCount || null} entities)`}
        </Title>

        {lang !== 'en' && type === 'text' ? (
          <CButton
            onClick={() => {
              translateText(contentDraft.data.en[name], lang, name);
            }}
            type="translate"
          >
            Translate
          </CButton>
        ) : null}
      </Col>
      <Col
        align="end"
        style={{
          display: 'flex'
        }}
      >
        {limits.map((item, i) => {
          const key = Object.keys(item)[0];
          const limits = ['characterLimit', 'sizeLimit', 'ratioWidth', 'ratioHeight'];
          if (limits.includes(key)) {
            return (
              <div key={i} style={{ paddingRight: '40px' }}>
                {`${key}:${item[key]}`}
              </div>
            );
          }
          return null;
        })}
      </Col>
      <Col align="center" span={24}>
        {children}
      </Col>
    </Row>
  );
};

export default FieldElement;
